import { z } from 'zod';

import { UNKNOWN_ENUM_VALUE } from '@/shared/utils/enum/enum.constants';

// Validates that a value is present (not null/undefined) without checking its
// type. Used by codegen for non-null GraphQL custom scalars:
// (Decimal, DateTime, JSON) can have varied runtime shapes, so we only enforce
// presence — the typed codegen output already covers shape at compile time.
export const zRequired = z.custom<unknown>(
  (v) => v !== null && v !== undefined,
  { message: 'required' },
);

// Enums with an UNKNOWN member tolerate values the schema isn't regenerated for
// yet, remapping any unrecognized string to UNKNOWN.
export const zEnumWithUnknownFallback = <
  U extends string,
  T extends readonly [U, ...U[]],
>(
  values: T,
) => {
  const enumSchema = z.enum(values);
  const knownValues = values as readonly string[];
  if (!knownValues.includes(UNKNOWN_ENUM_VALUE)) {
    return enumSchema;
  }
  return z.preprocess(
    (value) =>
      typeof value === 'string' && !knownValues.includes(value)
        ? UNKNOWN_ENUM_VALUE
        : value,
    enumSchema,
  );
};
